import Api from '../Base'

class DeleteShelfArtifact extends Api {
  requestUrl = `/api/shelfArtifact/${this.getParams().id}`

  method = 'DELETE'
}

export default DeleteShelfArtifact
